import * as React from 'react';
import styled from 'styled-components';
import { utils } from 'kb-shared';
import CalculatorFieldBase from './CalculatorField';
import ResultDiv from './ResultDiv';
import Footnotes from './Footnotes';
import { Row, Column } from '../../../../styled/Grid';
import useUserAge from '../../../../hooks/useUserAge';

const { getEggsRequired } = utils;

const FamilyPlanningCalculator = () => {
  const userAge = useUserAge();

  const [numKids, setNumKids] = React.useState(0);
  const [probability, setProbability] = React.useState(70);
  const [age, setAge] = React.useState(userAge || 0);

  return (
    <Aside>
      <h1>Family planning calculator</h1>
      <Row>
        <Column mobile={12} tablet={6} desktop={12}>
          <InputRow>
            <p>How many kids do you want?</p>
            <CalculatorField value={numKids} onValueChange={setNumKids} />
          </InputRow>
          <InputRow>
            <p>Chance you can have all children</p>
            <CalculatorField
              value={probability}
              onValueChange={setProbability}
              maxValue={100}
              postfix="%"
            />
          </InputRow>
          <InputRow>
            <p>Your age</p>
            <CalculatorField value={age} onValueChange={setAge} />
          </InputRow>
        </Column>

        <Column mobile={12} tablet={6} desktop={12}>
          <ResultDiv resultValue={getEggsRequired(numKids, probability, age)} />
        </Column>
      </Row>

      <Footnotes />
    </Aside>
  );
};

export default FamilyPlanningCalculator;

const CalculatorField = styled(CalculatorFieldBase)`
  /* TODO remove when hardcoded heigth is gone in CalculatorField */
  > div {
    height: initial;
  }
`;

const Aside = styled.aside`
  ${({ theme }) => theme.grid.container};
  background-color: ${({ theme }) => theme.colors.nightMedium};
  position: relative;

  h1 {
    ${({ theme }) => theme.typos.subsectionHeader};
    color: ${({ theme }) => theme.colors.yellow};
    padding: 20px 0 15px;
  }
`;

const InputRow = styled.div`
  color: ${({ theme }) => theme.colors.white};
  display: flex;
  justify-content: space-between;
  align-items: flex-end;

  &:not(:last-child) {
    margin-bottom: 30px;
  }

  p {
    ${({ theme }) => theme.typos.bodyText};
    flex: 0 1 160px;
    margin-right: 5px;
    text-transform: uppercase;
  }

  ${CalculatorField} {
    flex: 0 0 65px;
  }
`;
